/**
 *  【消息推送】入口页
 * */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Main from './pages/main';
import { connect } from 'react-redux';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

const MessageMove = ({ history, match, setBreadcrumbPaths }) => {
    useEffect(() => {
        setBreadcrumbPaths(match);
    }, []);
    return <Main history={history} />;
};

MessageMove.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func
};

export default connect(null, { setBreadcrumbPaths })(MessageMove);